module.exports = "/images/cinema.svg?13e274a51c1db234b94ae5b0988a18f0";